/* RD2 guard 2026-10-23: the file can be loaded both by the drawer snippet and by the re-rendered widget; initialise once only. */
if (!window.__reUpsellLoaded) {
window.__reUpsellLoaded = true;
/**
 * Re. Upsell Widget - Cart Drawer
 * Version 4.2
 *
 * Changes from v4.1:
 * - Discount injection now uses two mechanisms for reliability:
 *   1. Injects a hidden `discount` input into #CartDrawer-Form so the code is
 *      included in the checkout POST payload (primary, always works)
 *   2. Calls /discount/CODE via fetch to set the _shopify_discount cookie (backup)
 * - Fixed: discount code was previously fire-and-forget with no guarantee it
 *   reached checkout; form injection makes it deterministic
 */
(function () {
  'use strict';

  // --------------------------------------------------------------------------
  // CART API HELPERS
  // --------------------------------------------------------------------------

  function cartAdd(variantId) {
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        id: parseInt(variantId, 10),
        quantity: 1,
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname,
      }),
    }).then(function (r) {
      if (!r.ok) {
        return r.json().then(function (e) {
          throw new Error(e.description || 'cart/add failed: ' + r.status);
        });
      }
      return r.json();
    });
  }

  function applyDiscount(code) {
    return fetch('/discount/' + encodeURIComponent(code), {
      credentials: 'same-origin',
    });
  }

  // --------------------------------------------------------------------------
  // CART DRAWER DOM UPDATE
  // Note: does NOT update the upsell widget — all_products is unavailable in
  // section renders so re-rendering the widget from sections would produce
  // empty cards. Widget state is managed via JS instead (see handleAdd).
  // --------------------------------------------------------------------------

  function applyCartSections(sections) {
    var parser = new DOMParser();

    if (sections['cart-drawer']) {
      var drawerDoc = parser.parseFromString(sections['cart-drawer'], 'text/html');

      // Update cart items
      var newItems = drawerDoc.querySelector('#CartDrawer-CartItems');
      var curItems = document.querySelector('#CartDrawer-CartItems');
      if (newItems && curItems) {
        curItems.innerHTML = newItems.innerHTML;
      }

      // Update totals
      var newTotals = drawerDoc.querySelector('#CartDrawer .totals');
      var curTotals = document.querySelector('#CartDrawer .totals');
      if (newTotals && curTotals) {
        curTotals.innerHTML = newTotals.innerHTML;
      }

      // Update footer (checkout button etc.)
      var newFooter = drawerDoc.querySelector('.cart-drawer__footer');
      var curFooter = document.querySelector('.cart-drawer__footer');
      if (newFooter && curFooter) {
        curFooter.innerHTML = newFooter.innerHTML;
      }

      // Sync is-empty state
      var newDI = drawerDoc.querySelector('.drawer__inner');
      var curDI = document.querySelector('cart-drawer .drawer__inner');
      if (newDI && curDI) {
        curDI.classList.toggle('is-empty', newDI.classList.contains('is-empty'));
      }

      // The cart-drawer element itself also carries is-empty. Leaving it on after
      // the cart goes empty -> non-empty makes the patched open() refetch sections
      // from '/' and overwrite the drawer with an empty upsell render.
      var drawerEl = document.querySelector('cart-drawer');
      if (drawerEl) drawerEl.classList.remove('is-empty');
      var itemsEl = document.querySelector('cart-drawer-items');
      if (itemsEl) itemsEl.classList.remove('is-empty');
    }

    // Update cart icon bubble (item count in header)
    if (sections['cart-icon-bubble']) {
      var bubbleDoc = parser.parseFromString(sections['cart-icon-bubble'], 'text/html');
      var newBubble = bubbleDoc.querySelector('.shopify-section');
      var curBubble = document.getElementById('cart-icon-bubble');
      if (newBubble && curBubble) {
        curBubble.innerHTML = newBubble.innerHTML;
      }
    }
  }

  // --------------------------------------------------------------------------
  // OPEN CART DRAWER
  // --------------------------------------------------------------------------

  function openCartDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    if (typeof drawer.open === 'function') {
      drawer.open();
    } else {
      drawer.classList.add('active');
      var overlay = document.getElementById('CartDrawer-Overlay');
      if (overlay) overlay.classList.add('active');
    }
  }

  // --------------------------------------------------------------------------
  // RESOLVE VARIANT ID FROM BUTTON OR CARD SELECT
  // --------------------------------------------------------------------------

  function getVariantId(btn) {
    var card = btn.closest('.re-upsell__card');
    if (card) {
      var sel = card.querySelector('[data-re-variant-select]');
      if (sel && sel.value) {
        return sel.value;
      }
    }
    return btn.getAttribute('data-re-upsell-add');
  }

  // --------------------------------------------------------------------------
  // INJECT DISCOUNT CODE INTO CART DRAWER FORM
  // Adds (or updates) a hidden <input name="discount"> on #CartDrawer-Form so
  // the code is included when the form is POST-ed to /cart on checkout.
  // This is the primary discount mechanism — it's deterministic and doesn't
  // rely on cookie state surviving to checkout.
  // --------------------------------------------------------------------------

  function injectDiscountIntoForm(code) {
    var form = document.getElementById('CartDrawer-Form');
    if (!form) return;
    var existing = form.querySelector('input[name="discount"]');
    if (existing) {
      existing.value = code;
    } else {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'discount';
      input.value = code;
      form.appendChild(input);
    }
  }

  // --------------------------------------------------------------------------
  // ENSURE DISCOUNT NOTE IS VISIBLE IN WIDGET
  // Called after a discounted item is successfully added. The server-rendered
  // widget may not have the note (if it was rendered before the item was added),
  // so we inject it via JS if it's missing.
  // --------------------------------------------------------------------------

  function ensureDiscountNote() {
    var widget = document.querySelector('[data-re-upsell-widget]');
    if (!widget) return;
    if (!widget.querySelector('.re-upsell__discount-note')) {
      var note = document.createElement('p');
      note.className = 're-upsell__discount-note';
      note.textContent = 'Discount applied at checkout';
      widget.appendChild(note);
    }
  }

  // --------------------------------------------------------------------------
  // HIDE WIDGET IF EMPTY (no cards and no discount note)
  // --------------------------------------------------------------------------

  function maybeHideWidget() {
    var widget = document.querySelector('[data-re-upsell-widget]');
    if (!widget) return;
    var products = widget.querySelector('.re-upsell__products');
    var hasCards = products && products.querySelectorAll('.re-upsell__card').length > 0;
    var hasNote = !!widget.querySelector('.re-upsell__discount-note');
    if (!hasCards && !hasNote) {
      widget.style.display = 'none';
    }
  }

  // --------------------------------------------------------------------------
  // HANDLE ADD BUTTON CLICK
  // --------------------------------------------------------------------------

  function handleAdd(btn) {
    var variantId = getVariantId(btn);
    if (!variantId) {
      console.warn('[Re.] No variant ID on upsell button');
      return;
    }

    var discountCode = btn.getAttribute('data-re-upsell-discount') || '';
    var card = btn.closest('.re-upsell__card');

    btn.disabled = true;
    var origHTML = btn.innerHTML;
    btn.innerHTML = 'Adding...';

    cartAdd(variantId)
      .then(function (data) {
        // Refresh cart items, totals, footer (NOT the widget — see applyCartSections note)
        if (data && data.sections) {
          applyCartSections(data.sections);
        }

        // Apply discount if this button carries a code
        if (discountCode) {
          // Primary: inject into the checkout form POST payload
          injectDiscountIntoForm(discountCode);
          // Backup: set the _shopify_discount cookie via the discount endpoint
          applyDiscount(discountCode).catch(function (err) {
            console.warn('[Re.] applyDiscount error:', err);
          });
          // Ensure the "Discount applied at checkout" note is visible
          ensureDiscountNote();
        }

        // Open the drawer
        openCartDrawer();

        // Show "Added!" briefly, then remove the card entirely
        btn.innerHTML = 'Added!';
        setTimeout(function () {
          if (card) {
            card.remove();
            maybeHideWidget();
          } else {
            btn.innerHTML = origHTML;
            btn.disabled = false;
          }
        }, 800);
      })
      .catch(function (err) {
        console.warn('[Re.] handleAdd error:', err.message || err);
        btn.innerHTML = origHTML;
        btn.disabled = false;
      });
  }

  // --------------------------------------------------------------------------
  // DISMISS BUTTON
  // --------------------------------------------------------------------------

  function handleDismiss(btn) {
    var widget = btn.closest('[data-re-upsell-widget]');
    if (widget) {
      widget.style.display = 'none';
    }
  }

  // --------------------------------------------------------------------------
  // INIT — event delegation so handlers survive DOM re-renders
  // --------------------------------------------------------------------------

  function init() {
    document.addEventListener('click', function (e) {
      var addBtn = e.target.closest('[data-re-upsell-add]');
      if (addBtn) {
        e.preventDefault();
        handleAdd(addBtn);
        return;
      }
      var dismissBtn = e.target.closest('[data-re-upsell-dismiss]');
      if (dismissBtn) {
        e.preventDefault();
        handleDismiss(dismissBtn);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();

/* RE-FIX dedupe 2026-10-05: never show more than one upsell widget in the cart drawer */
(function () {
  function dedupe() {
    var w = document.querySelectorAll('cart-drawer [data-re-upsell-widget]');
    for (var i = 0; i < w.length - 1; i++) { w[i].remove(); }
  }
  function start() {
    var d = document.querySelector('cart-drawer');
    if (!d) return;
    new MutationObserver(dedupe).observe(d, { childList: true, subtree: true });
    dedupe();
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', start); } else { start(); }
})();

}
